import clsx from 'clsx'
import classes from './LastFive.module.css'
import { ReactComponent as Won } from '../../assets/won.svg'
import { ReactComponent as Loss } from '../../assets/loss.svg'
import { ReactComponent as Draw } from '../../assets/draw.svg'
import { LastFiveMatches } from '../../teams/api'

export default function LastFiveComponent({
  last_five,
}: {
  last_five: LastFiveMatches
}) {
  return (
    <div className={classes.last_five}>
      {[...last_five].reverse().map((result, index) => {
        const isLast = index === last_five.length - 1

        if (result === 'win') {
          return (
            <div
              key={index}
              className={clsx(classes.last_five_item, {
                [classes.underline_green]: isLast,
              })}
            >
              <Won className={clsx(classes.icon, classes.up)} />
            </div>
          )
        }

        if (result === 'loss') {
          return (
            <div
              key={index}
              className={clsx(classes.last_five_item, {
                [classes.underline_red]: isLast,
              })}
            >
              <Loss className={clsx(classes.icon, classes.down)} />
            </div>
          )
        }

        return (
          <div
            key={index}
            className={clsx(classes.last_five_item, {
              [classes.underline_black]: isLast,
            })}
          >
            <Draw className={classes.icon} />
          </div>
        )
      })}
    </div>
  )
}
